import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const LineChartGraph = props => {
  return (
      <ResponsiveContainer width="100%" minHeight={300}>
        <LineChart
          data={props.data}
          margin={{
            top: 5,
            right: 5,
            left: -25,
            bottom: 45,
          }}
        >
          <CartesianGrid />
          <XAxis xAxisId="0" dataKey="month" />
          <XAxis xAxisId="1" dataKey="year" allowDuplicatedCategory={false} />
          <YAxis />
          <Legend />
          <Tooltip />
          <Line dataKey="total" stroke="#8884D8" activeDot={{ r: 4 }} />
          <Line dataKey="success" stroke="#0BD11E" activeDot={{ r: 4 }} />
        </LineChart>
      </ResponsiveContainer>
  );
}

export default LineChartGraph

